import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { FC, useMemo } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { StripePaymentForm } from "./StripePaymentForm";

export type StripeKeys = { clientSecret: string; publishableKey: string };

export const StripeWrapper: FC<
  StripeKeys & {
    customerEmail?: string;
    onCancel: VoidFunction;
    onComplete: () => Promise<void>;
  }
> = ({ clientSecret, onCancel, onComplete, publishableKey }) => {
  const stripe = useMemo(() => loadStripe(publishableKey), [publishableKey]);
  const [locale] = useLanguage();

  return (
    <Elements options={{ clientSecret, locale }} stripe={stripe}>
      <StripePaymentForm onCancel={onCancel} onComplete={onComplete} />
    </Elements>
  );
};
